import { Avatar } from '@zendeskgarden/react-avatars'
import React from 'react'

import InboundClassIcon from '../../icons/msg_inbound_class.svg?react'

/** @deprecated */
export const GroupAvatar = (props: { size?: 'small' | 'large'; style?: React.CSSProperties }) => {
    return (
        <Avatar size={props.size ? props.size : 'large'} style={props.style}>
            <InboundClassIcon width="48" height="48" style={{ width: '48px', height: '48px' }} />
        </Avatar>
    )
}
